import { headers, baseUrl } from "../../common/credentials";

const port = "8000";
const port1 ="3501";

export const getFileUploadListFromServer = () => {
    let url = baseUrl + port1 + "/api/v2/alcs/generic/file_uploads/";
    return ([headers, url]);
}

export const getFileList = () => {
    let url = baseUrl + port1 + "/api/v2/alcs/file_type_list/";
    return ([headers, url]);
}